<template>
  <div class="m-discount-manual">
    <hr>
    <span class="m-discount-manual__headline">{{ $t('DiscountInputHeadline', 'Rabat') }}</span>
    <div class="m-discount-manual__content">
      <base-input
        v-model="discountInput"
        v-validate="'numeric|min:1'"
        :error-message="$t('DiscountInputErrorMsg', 'Rabatten skal være heltal, altså uden tusind separator og decimaler.')"
        class="m-discount-manual__input"
        :class="{ '-invalid': hasValidationError }"
        :disabled="basket.orderSummary.totalDiscount > 0"
        :placeholder="$t('DiscountInputPlaceholder', 'F.eks.: 1000')"
      />
      <base-button
        v-if="basket.orderSummary.totalDiscount > 0"
        class="m-discount-manual__button -secondary"
        @click="removeDiscount"
      >
        <base-loader v-if="showLoader" />
        <base-icon
          v-else-if="showTick"
          class="m-discount-manual__button-icon"
          icon="checkmark"
        />
        <span v-else>{{ $t('DiscountInputRemoveButton', 'Fjern') }}</span>
      </base-button>
      <base-button
        v-else
        class="m-discount-manual__button -secondary"
        @click="addDiscount"
      >
        <base-loader v-if="showLoader" />
        <base-icon
          v-else-if="showTick"
          class="m-discount-manual__button-icon"
          icon="checkmark"
        />
        <span v-else>{{ $t('DiscountInputAddButton', 'Tilføj') }}</span>
      </base-button>
    </div>
    <div v-if="hasResponseAddError || hasResponseRemoveError" class="text-small bg-red color-white p-4 mt-4">
      <span class="semibold pb-2 d-block">{{ $t('DiscountInputErrorHeadline', 'Vi beklager') }}</span>
      <div v-if="hasResponseAddError">
        {{ $t('DiscountInputAddErrorText', 'Noget gik galt ved forsøg på at tilføje rabatten. Prøv evt. igen eller kontakt Brønnum.') }}
      </div>
      <div v-else-if="hasResponseRemoveError">
        {{ $t('DiscountInputRemoveErrorText', 'Noget gik galt ved forsøg på at fjerne rabatten. Prøv evt. igen eller kontakt Brønnum.') }}
      </div>
    </div>
  </div>
</template>


<script>
import BaseInput from '@/components/atoms/BaseInput.vue';
import BaseButton from '@/components/atoms/BaseButton.vue';
import BaseLoader from '@/components/atoms/BaseLoader.vue';
import BaseIcon from '@/components/atoms/BaseIcon.vue';

export default {
  name: 'DiscountManual',
  components: {
    BaseInput,
    BaseButton,
    BaseLoader,
    BaseIcon
  },
  fetch () {
    this.discountInput = this.basket.orderSummary.totalDiscountExVat > 0 ? this.basket.orderSummary.totalDiscountExVat : '';
  },
  data () {
    return {
      discountInput: '',
      showLoader: false,
      showTick: false,
      hasValidationError: false,
      hasResponseAddError: false,
      hasResponseRemoveError: false,
    }
  },
  computed: {
    basket () {
      return this.$store.getters['cart/basket/getBasket'];
    },
    culture () {
      return this.$store.getters['site/getCurrentCulture']
    }
  },
  methods: {
    async addDiscount () {
      await this.$validator.validate();

      let value = parseFloat(this.discountInput);
      // Validate
      if (isNaN(value) || parseFloat(value) <= 0) {
        this.hasValidationError = true;
        return;
      }

      this.showLoader = true;
      this.hasResponseAddError = false;
      this.hasValidationError = false;

      try {
        // Add discount
        await this.$repositories.order.setOrderDiscount(value);
      } catch {
        this.showLoader = false;
        this.hasResponseAddError = true;
        return;
      }

      await this.$store.dispatch('cart/basket/fetchBasket', { culture: this.culture });

      this.showLoader = false;
      this.showTick = true;
      setTimeout(() => {
        this.showTick = false;
      }, 2000);
    },
    async removeDiscount () {
      this.showLoader = true;
      this.hasResponseRemoveError = false;

      try {
        // Remove discount
        await this.$repositories.order.setOrderDiscount(0);
      } catch {
        this.showLoader = false;
        this.hasResponseRemoveError = true;
        return;
      }

      await this.$store.dispatch('cart/basket/fetchBasket', { culture: this.culture });

      this.discountInput = '';
      this.showLoader = false;
      this.showTick = true;
      setTimeout(() => {
        this.showTick = false;
      }, 2000);
    }
  }
}
</script>